module.exports = __webpack_public_path__ + "static/media/moto_insurance_companycar.2e7862a6.svg";